import * as Sentry from '@sentry/react';
import { ConvexError } from 'convex/values';

export function isExpectedError(error: unknown): boolean {
  return (
    error instanceof ConvexError &&
    (error.data as { expected?: unknown }).expected === true
  );
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_VERCEL_ENV || 'development',
  release:
    import.meta.env.VERCEL_GIT_COMMIT_SHA ||
    import.meta.env.VITE_SENTRY_RELEASE,
  enableLogs: true,
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: import.meta.env.VITE_VERCEL_ENV === 'production' ? 0.1 : 0,
  replaysSessionSampleRate:
    import.meta.env.VITE_VERCEL_ENV === 'production' ? 0.1 : 0,
  replaysOnErrorSampleRate:
    import.meta.env.VITE_VERCEL_ENV !== 'development' ? 1.0 : 0,
  beforeSend(event, hint) {
    if (isExpectedError(hint.originalException)) return null;
    return event;
  },
});
